<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard v-if="!loadingInitialValue">
          <LocationAdditionalChargeDetails
            @submitted="submitted"
            :loading="loading"
            :locationAdditionalCharge="locationAdditionalCharge"
          ></LocationAdditionalChargeDetails>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import LocationAdditionalChargeDetails from "@/components/settings/pricing/LocationAdditionalChargeDetails.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "create_location_additional_charge",
  components: {
    SimpleCard,
    LocationAdditionalChargeDetails
  },
  data: function() {
    return {
      loading: false,
      loadingInitialValue: true,
      fixedCost: null,
    };
  },
  mounted: async function() {

    if (this.$route.query.copyFrom == null) {
      this.loadingInitialValue = false;
      return;
    }

  },
  methods: {
    success: function(data) {
      this.$router.push("/settings/pricing/parking_and_tolls/" + data.location_additional_charge.id);
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    },
    submitted: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      p = JSON.parse(JSON.stringify(p))
      p.amount = (p.amount * 100)

      var url = `${this.$store.state.apiUrl}/location_additional_charge/create`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: p,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            completed(res.data);
          } else {
            failed(res.data.error);
          }
        })
        .catch(function(err) {
          failed("internal_server_error");
          console.error(err);
        });
    }
  }
};
</script>
